export type PhoneLengthRange = { min: number; max: number };

export const COUNTRY_PHONE_LENGTHS: Record<string, PhoneLengthRange> = {
  "United States": { min: 10, max: 10 },
  "Canada": { min: 10, max: 10 },
  "United Kingdom": { min: 9, max: 10 },
  "Australia": { min: 9, max: 9 },
  "Germany": { min: 10, max: 11 },
  "France": { min: 9, max: 9 },
  "Italy": { min: 9, max: 10 },
  "Japan": { min: 10, max: 10 },
  "China": { min: 11, max: 11 },
  "Brazil": { min: 10, max: 11 },
  "Russia": { min: 10, max: 10 },
  "Mexico": { min: 10, max: 10 },
  "Spain": { min: 9, max: 9 },
  "South Korea": { min: 10, max: 11 },
  "United Arab Emirates": { min: 9, max: 9 },
  "Saudi Arabia": { min: 9, max: 9 },
  "Singapore": { min: 8, max: 8 },
  "South Africa": { min: 9, max: 9 },
  "New Zealand": { min: 8, max: 10 },
  "Albania": { min: 8, max: 9 },
  "Austria": { min: 10, max: 13 },
  "Belgium": { min: 8, max: 10 },
  "Bosnia-Herzegovina": { min: 8, max: 9 },
  "Botswana": { min: 7, max: 8 },
  "Bulgaria": { min: 8, max: 9 },
  "Croatia": { min: 8, max: 9 },
  "Cyprus": { min: 8, max: 8 },
  "Czech Republic": { min: 9, max: 9 },
  "Denmark": { min: 8, max: 8 },
  "Estonia": { min: 7, max: 8 },
  "Finland": { min: 5, max: 12 },
  "French Polynesia": { min: 6, max: 8 },
  "Ghana": { min: 9, max: 9 },
  "Greece": { min: 10, max: 10 },
  "Hungary": { min: 8, max: 9 },
  "Iceland": { min: 7, max: 9 },
  "Ireland": { min: 7, max: 9 },
  "Israel": { min: 8, max: 9 },
  "Kosovo": { min: 8, max: 8 },
  "Latvia": { min: 8, max: 8 },
  "Lesotho": { min: 8, max: 8 },
  "Lithuania": { min: 8, max: 8 },
  "Macedonia": { min: 8, max: 8 },
  "Malta": { min: 8, max: 8 },
  "Moldova": { min: 8, max: 8 },
  "Montenegro": { min: 8, max: 8 },
  "Namibia": { min: 9, max: 9 },
  "Netherlands": { min: 9, max: 9 },
  "North Macedonia": { min: 8, max: 8 },
  "Norway": { min: 8, max: 8 },
  "Poland": { min: 9, max: 9 },
  "Portugal": { min: 9, max: 9 },
  "Romania": { min: 9, max: 9 },
  "Serbia": { min: 8, max: 9 },
  "Slovak Republic": { min: 9, max: 9 },
  "Slovakia": { min: 9, max: 9 },
  "Slovenia": { min: 8, max: 8 },
  "Swaziland": { min: 8, max: 8 },
  "Eswatini": { min: 8, max: 8 },
  "Sweden": { min: 7, max: 13 },
  "Switzerland": { min: 9, max: 9 },
  "Turkey": { min: 10, max: 10 },
  "Ukraine": { min: 9, max: 9 },
  // LATAM (herba_sa market)
  "Argentina": { min: 10, max: 10 },
  "Bolivia": { min: 8, max: 8 },
  "Chile": { min: 9, max: 9 },
  "Colombia": { min: 10, max: 10 },
  "Costa Rica": { min: 8, max: 8 },
  "Ecuador": { min: 9, max: 9 },
  "El Salvador": { min: 8, max: 8 },
  "Guatemala": { min: 8, max: 8 },
  "Honduras": { min: 8, max: 8 },
  "Nicaragua": { min: 8, max: 8 },
  "Panama": { min: 7, max: 8 },
  "Panamá": { min: 7, max: 8 },
  "Paraguay": { min: 9, max: 9 },
  "Peru": { min: 9, max: 9 },
  "Perú": { min: 9, max: 9 },
  "Uruguay": { min: 8, max: 8 },
  "Venezuela": { min: 10, max: 10 },
};

const stripAccents = (value: string) =>
  value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const getCountryPhoneLength = (
  countryName?: string
): PhoneLengthRange | undefined => {
  if (!countryName) return undefined;

  const direct = COUNTRY_PHONE_LENGTHS[countryName];
  if (direct) return direct;

  const normalizedName = stripAccents(countryName);
  return Object.entries(COUNTRY_PHONE_LENGTHS).find(
    ([name]) => stripAccents(name) === normalizedName
  )?.[1];
};
